module.exports = __webpack_public_path__ + "img/d02.b995cdaa.jpg";